import React, { useState } from "react";
import { Box, Button, Divider } from "@mui/material";
import AvailableJob from "./subTable/AvailableJob";
import AllBatch from "./subTable/AllBatch";
import Completed from "./subTable/Completed";
import Accepted from "./subTable/Accepted";
import Incomplete from "./subTable/Incomplete";
import NotAccepted from "./subTable/NotAccepted";
import axios from "axios";
import { useParams } from "react-router-dom";
import ModalToCreateJobBatches from "../ModalToCreateJobBatches";

const JobsActionPanel = ({
  isDisabled,
  openModalToCreateJobBatches,
  setOpenModalToCreateJobBatches,
}) => {
  const { id } = useParams();
  const [availableJobs, setAvailableJobs] = React.useState([]);
  const [availableBatches, setAvailableBatches] = React.useState([]);
  const [acceptedBatches, setAcceptedBatches] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const serviceName = "Audit";
  const serviceType = 2;
  const filters = [
    "Available Jobs",
    "All Batches",
    "Incomplete",
    "Not Accepted",
    "Accepted",
    "Completed",
  ];

  const actions = [
    // "Create Lots Manually",

    "Create Batches",
    // "Publish All Batches",
  ];

  const [selectedFilter, setSelectedFilter] = useState("Available Jobs");
  const [activeTable, setActiveTable] = useState("Available Jobs");
  const fetchAllJobsBasedOnCampaignId = async () => {
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_URL
        }/jobs/getAllJobs?campaignId=${id}&serviceType=${2}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data?.success) {
        const allJobs = response.data.data;

        setForBatch(allJobs);

        const filteredJobs = allJobs.filter(
          (job) =>
            !job.batchOfJobsForInstallationPartnerId && job.serviceType == "2"
        );

        setAvailableJobs(filteredJobs); // render all jobs
      }
    } catch (error) {
      console.error("Error while fetching jobs", error);
    }
  };

  const fetchDataBasedOnFilter = async (filter) => {
    if (filter === "Available Jobs") {
      await fetchAllJobsBasedOnCampaignId();
    } else if (filter === "All Batches") {
      await fetchAllBatchesBasedOnCampaignId();
    } else if (filter === "Incomplete") {
      await fetchAcceptedBatches();
    } else if (filter === "Not Accepted") {
      await fetchAcceptedBatches();
    } else if (filter === "Accepted") {
      await fetchAcceptedBatches();
    } else if (filter === "Completed") {
      await fetchAcceptedBatches();
    }
  };
  const [forbatch, setForBatch] = useState([]);

  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    setActiveTable(filter);
  };
  // Fetch available Batches
  const fetchAllBatchesBasedOnCampaignId = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchJobs?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.success) {
        const allBatches = response.data.data;

        const AllBatchesInAudit = allBatches.filter(
          (batch) =>
            !batch.hasOwnProperty("installationPartnerId") &&
            batch.serviceType == "2"
        );
        setAvailableBatches(AllBatchesInAudit);
      }
    } catch (error) {
      console.error("error in while fetching jobs", error);
    }
  };
  const [isNotAccepted, setIsNotAccepted] = useState([]);

  let batchId = [];

  // Fetch accepted batches for the "Accepted" filter
  const fetchAcceptedBatches = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/batchOfJobs/getAllBatchJobs?campaignId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data?.success) {
        const allBatches = response.data.data;

        const notAcceptedBatches = allBatches.filter(
          (batch) =>
            !batch.hasOwnProperty("installationPartnerId") &&
            batch.serviceType == "2"
        );

        setIsNotAccepted(notAcceptedBatches);
        // Filter batches where installationPartnerId is present
        const filteredAcceptedBatches = allBatches.filter(
          (batch) => batch.installationPartnerId && batch.serviceType == "2"
          // batch.installationPartnerId.trim() !== ""
        );

        setAcceptedBatches(filteredAcceptedBatches);
      }
    } catch (error) {
      console.error("Error while fetching accepted batches", error);
    }
  };

  const matchingJobs = forbatch.filter((job) =>
    batchId.includes(job.batchOfJobsForInstallationPartnerId)
  );

  React.useEffect(() => {
    if (id) {
      fetchDataBasedOnFilter(selectedFilter);
    }
  }, [id, selectedFilter]);

  // Handle action clicks
  const handleActionClick = async (action) => {
    if (action === "Create Batches") {
      setOpenModalToCreateJobBatches(true);
    }
  };

  // Conditionally render actions based on the selected filter
  const filteredActions = actions.filter((action) => {
    if (
      selectedFilter === "Available Jobs" &&
      action === "Publish All Batches"
    ) {
      return false; // Remove "Publish All Batches" for Available Jobs
    }
    if (selectedFilter === "Not Accepted" && action === "Create Batches") {
      return false; // Remove "Create Batches" for Not Accepted
    }
    if (selectedFilter === "All Batches" && action !== "Publish All Batches") {
      return false; // Only show "Publish All Batches" for All Batches
    }
    return true; // Include other actions as normal
  });

  return (
    <div>
      {/* Divider */}
      <Divider sx={{ marginBottom: "1rem" }} />

      {/* Filters and Actions Container */}
      <div
        className="flex flex-wrap justify-between items-center gap-4"
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginBottom: "1rem",
          marginLeft: "1rem",
          marginRight: "1rem",
        }}
      >
        {/* Left Section: Filters */}
        <div
          className="filters-section"
          style={{ flex: 1, display: "flex", gap: "8px", flexWrap: "wrap" }}
        >
          {filters.map((filter) => (
            <Button
              variant="outlined"
              key={filter}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: selectedFilter === filter ? "white" : "black",
                borderColor:
                  selectedFilter === filter ? "transparent" : "#d9dadb",
                backgroundColor:
                  selectedFilter === filter ? "black" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedFilter === filter ? "black" : "transparent",
                  borderColor:
                    selectedFilter === filter ? "transparent" : "#d9dadb",
                },
              }}
              onClick={() => handleFilterClick(filter)}
            >
              {filter}
            </Button>
          ))}
        </div>

        {/* Right Section: Actions */}
        {selectedFilter !== "Completed" &&
          selectedFilter !== "Accepted" &&
          selectedFilter !== "Incomplete" && (
            <div
              className="actions-section"
              style={{
                flex: "0 1 auto",
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              {filteredActions.map((action, index) => (
                <Button
                  key={action}
                  variant={index === 2 ? "contained" : "outlined"}
                  color={index === 2 ? "primary" : undefined}
                  disabled={
                    isDisabled === "recce" ||
                    (action === "Create Batches" &&
                      selectedFilter === "All Batches")
                  }
                  sx={{
                    fontSize: "0.8rem",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "4px 12px",
                    color:
                      index === 0 ? "#418cff" : index === 2 ? "white" : "black",
                    borderColor: "#418cff",
                    backgroundColor:
                      isDisabled === "recce"
                        ? "#d9dadb"
                        : index === 2
                        ? "primary.main"
                        : "transparent",
                    "&.Mui-disabled": {
                      backgroundColor:
                        action === "Create Batches" &&
                        selectedFilter === "All Batches"
                          ? "#d9dadb"
                          : "#d9dadb",
                      color: "white",
                      border: "none",
                    },
                  }}
                  onClick={() => handleActionClick(action)}
                >
                  {action}
                </Button>
              ))}
            </div>
          )}
      </div>

      {/* Dynamic Table Rendering */}
      <Box sx={{ marginTop: "1rem" }}>
        {activeTable === "Available Jobs" && (
          <AvailableJob
            setAvailableJobs={setAvailableJobs}
            availableJobs={availableJobs}
            setSelectAll={setSelectAll}
            selectAll={selectAll}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
          />
        )}
        {activeTable === "All Batches" && (
          <AllBatch
            availableBatches={availableBatches}
            setAvailableBatches={setAvailableBatches}
            availableJobs={forbatch}
          />
        )}
        {activeTable === "Incomplete" && (
          <Incomplete
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
          />
        )}
        {activeTable === "Not Accepted" && (
          <NotAccepted
            isNotAccepted={isNotAccepted}
            setAcceptedBatches={setAcceptedBatches}
            matchingJobs={matchingJobs}
          />
        )}
        {/* {activeTable === "Accepted" && <Accepted />} */}
        {activeTable === "Accepted" && (
          <Accepted
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
          />
        )}
        {/* {activeTable === "Completed" && <Completed />} */}
        {/* {activeTable === "Completed" && (
          <Completed
            completedBatches={completedBatches}
            setCompletedBatches={setCompletedBatches}
          /> 
        )}*/}
        {activeTable === "Completed" && (
          <Completed
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
          />
        )}
        {openModalToCreateJobBatches && (
          <ModalToCreateJobBatches
            serviceName={serviceName}
            selectedJobs={selectedJobs}
            setSelectedJobs={setSelectedJobs}
            serviceTypeDynamic={serviceType}
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
            campaignData={id}
            availableJobs={availableJobs}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
          />
        )}
      </Box>
    </div>
  );
};

export default JobsActionPanel;
